import { render, staticRenderFns } from "./conservStat.vue?vue&type=template&id=c473fe98"
import script from "./conservStat.vue?vue&type=script&lang=js"
export * from "./conservStat.vue?vue&type=script&lang=js"
import style0 from "./conservStat.vue?vue&type=style&index=0&id=c473fe98&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports